import script from "./VideoData.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoData.vue?vue&type=script&setup=true&lang=js"

import "./VideoData.vue?vue&type=style&index=0&id=263cb77b&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-263cb77b"]])

export default __exports__